export default __webpack_public_path__ + "static/media/stacked-waves-haikei.ecb59133.png";